import { css } from "lit";

export const expandTextStyles = css`
  :host {
    display: block;
    line-height: inherit;
  }

  .wrapper {
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  /* Collapsed state */
  :host(:not([expanded])) .text {
    /* Modern standard */
    line-clamp: var(--line-clamp);

    /* WebKit fallback */
    display: -webkit-box;
    -webkit-line-clamp: var(--line-clamp);
    -webkit-box-orient: vertical;

    overflow: hidden;
    text-overflow: ellipsis;
  }

  .text {
    white-space: pre-line;
  }

  .toggle {
    color: var(--sds-color-text-default-tertiary, #888);
    font-weight: bold;
    cursor: pointer;
    margin-top: 4px;
    display: inline-block;
  }
`;
